/* ==========================================================================
   SearcherFlightHotelRxjs > Constants
   ========================================================================== */

/* Exports */
module.exports = {
    ORIGIN: {
        icon: 'marker',
        limit: 20,
        threshold: 3,
        types: ['AER']
    },
    DESTINATION: {
        icon: 'earth-planet',
        limit: 20,
        threshold: 3,
        types: ['ISL', 'CIU', 'ZON', 'HOT'],
        operator: 'or',
        codes: ['PAK']
    },
    CALENDAR: {
        mode: 'range',
        DATE_FORMAT: 'yyyy-LL-dd',
        ARIA_FORMAT: 'YYYY-MM-DD',
        stringDateFormat: 'dd LLLL yyyy',
        dateFormat: 'Y-m-d',
        ariaDateFormat: 'Y-m-d',
        static: false,
        inline: true,
        showMonths: 2,
        sameDay: false,
        releaseDays: 2
    },
    ACCOMMODATION: {
        maxRooms: 4,
        maxPeople: 9,
        adults: {
            min: 1,
            max: 6,
            value: 1
        },
        children: {
            min: 0,
            max: 4,
            value: 0,
            maxAge: 17,
            defaultAge: 4
        },
        rooms: [
            {
                adults: 2,
                children: 0
            }
        ]
    },
    LOADING: {
        LOADING_SRC: '/contenidos/fotos/CIUDADES/',
        LOADING_ALTERNATIVE: '/comun/images/lineas/paquetes_800x600.jpg'
    },
    URL_SUBMIT: '/packagesasyncstepssp/AvailabilityMaterial',
    ENDPOINTS: {
        OPERATIVE: '/packagesalexswc/AjaxServices/GetFlightOperative',
        DISCOUNTS: '/packagesalexswc/AjaxServices/ApplicableDiscounts',
        AIRPORT_BY_DESTINATION: '/packagesalexswc/AjaxServices/GetAirportCodeByDestination'
    }
};
